import styled, { css } from 'styled-components/macro'
import { miniPanelStyle, blueGradient, blueGradientHover, squircle } from 'src/global/helpers'

type WrapperProps = {
  $isDismissed: boolean
  $isFaded: boolean
}

export const Wrapper = styled.div<WrapperProps>`
  position: relative;
  width: 720px;
  max-height: 500px;
  ${squircle(40)}
  margin-top: 0;
  background: ${blueGradient};
  box-shadow: 0 8px 24px rgba(17, 183, 243, 0.22), 0 2px 6px rgba(17, 183, 243, 0.18);
  overflow: hidden;
  transform-origin: center center;
  transition: opacity 0.28s ease 0.08s, transform 0.32s cubic-bezier(0.4, 0, 0.2, 1) 0.08s, max-height 0.28s ease,
    margin 0.28s ease;

  @media (max-width: 768px) {
    width: min(1024px, calc(100vw - 32px)) !important;
    margin-right: 0;
    margin-bottom: 50px;
  }

  ${props =>
    props.$isDismissed &&
    css`
      transform-origin: bottom left;
      opacity: 0;
      transform: translate(-80px, 60px) scale(0.35);
      max-height: 0;
      margin-top: 0 !important;
      margin-bottom: 0;
      pointer-events: none;
      transition: opacity 0.32s ease, transform 0.32s cubic-bezier(0.4, 0, 0.2, 1), max-height 0.35s ease 0.18s,
        margin 0.35s ease 0.18s;
    `}

  ${props =>
    props.$isFaded &&
    css`
      transform-origin: center center;
      transform: scale(0.3);
      opacity: 0;
      pointer-events: none;
      transition: transform 0.34s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.2s ease-in-out 0.1s;
    `}

  .glass {
    padding: 24px 32px;
    border-radius: 12px;
    color: #ffffff;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  .badge {
    position: absolute;
    bottom: 0;
    left: 0;
    padding: 6px 12px 6px 16px;
    border-bottom-left-radius: 40px;
    border-top-right-radius: 40px;
    corner-shape: squircle;
    background: rgba(255, 255, 255, 0.28);
    font-size: 11px;
    font-weight: 700;
    color: #ffffff;
  }

  .title {
    margin: 0 0 8px 0;
    font-size: 16px;
    font-weight: 700;
    line-height: 1.3;
    color: #ffffff;
  }

  .description {
    margin: 0 0 16px 0;
    font-size: 14px;
    font-weight: 500;
    line-height: 1.4;
    color: rgba(255, 255, 255, 0.92);
  }

  .cta {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 12px 24px;
    background: rgba(255, 255, 255, 0.22);
    border: 1px solid rgba(255, 255, 255, 0.35);
    ${squircle(40)}
    font-size: 14px;
    font-weight: 600;
    color: #ffffff;
    cursor: pointer;
    transition: background 0.2s ease;
  }

  .cta:hover {
    background: rgba(255, 255, 255, 0.35);
  }
`

type MiniProps = {
  $isVisible: boolean
}

export const MiniWrapper = styled.div<MiniProps>`
  ${miniPanelStyle}
  background: ${blueGradient};
  box-shadow: 0 4px 12px ${props => props.theme.blue}33;
  transition: opacity 0.25s ease, transform 0.25s ease, max-height 0.3s ease, margin 0.3s ease, padding 0.3s ease,
    background 0.2s ease;

  opacity: ${props => (props.$isVisible ? 1 : 0)};
  transform: ${props => (props.$isVisible ? 'translateY(0)' : 'translateY(-8px)')};
  max-height: ${props => (props.$isVisible ? '60px' : '0')};
  margin-top: ${props => (props.$isVisible ? '16px' : '0')};
  padding: ${props => (props.$isVisible ? '12px 16px 12px 14px' : '0 16px 0 14px')};
  pointer-events: ${props => (props.$isVisible ? 'auto' : 'none')};

  :hover {
    background: ${blueGradientHover};
  }
`
